import React, { useEffect, useState } from 'react';
import DetailRow, { DetailRowProps } from './CustomComponents/DetailRow';
import { TreeNodeDTO } from 'business/models/Models';
import RecentDocumentService from 'business/services/RecentDocumentService';
import { getTreeNodeImageProps } from 'utils/Global';
export default function RecentlyOpened() {
  const [list, setList] = useState<DetailRowProps[]>([]);
  const [recentDocs, setRecentDocs] = useState<TreeNodeDTO[]>([]);

  useEffect(() => {
    async function fetchData() {
      const recentDocumentService = new RecentDocumentService();
      const recentDocs: TreeNodeDTO[] =
        await recentDocumentService.getUserRecentDocuments();
      setRecentDocs(recentDocs);
    }
    fetchData();
  }, []);
  useEffect(() => {
    const recentOpenedList = [];
    recentDocs?.forEach((docs) => {
      const row: DetailRowProps = {
        text: docs.name,
        startingIcon: getTreeNodeImageProps(docs),
        backGroundClr: 'white',
        fontClr: 'black',
        node: docs,
      };
      recentOpenedList.push(row);
    });
    setList([...recentOpenedList]);
  }, [recentDocs]);
  function getRows() {
    const render = [];
    list.map((l, index) => {
      l.rowClassName = 'recentOpenedDetailRow';
      render.push(<DetailRow key={`recently-opened-document-${index}`} {...l} />);
    });
    return render;
  }
  return (
    <div
      id='recentlyopened-container'
      className="recentOpened sectionBorder"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div id='recentlyopened-header' className="gridColumnHeader">Recently Opened</div>
      <div id='recentlyopened-body' className="recentOpenedBody">{getRows()}</div>
    </div>
  );
}
